import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/helpdesk/')({
  beforeLoad: () => {
    // Redirect to dashboard when accessing the helpdesk root
    throw redirect({
      to: '/helpdesk/dashboard'
    })
  }
})